// extracted by mini-css-extract-plugin
export default {"job":"W3I7tieh","author":"On6Oj532","body":"sYFAppUw"};